<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Turno" prop="turno" :rules="[$requiredChange]" key="turno">
              <el-select v-model="dados.turno">
                <el-option label="MANHÃ" value="manha"></el-option>
                <el-option label="TARDE" value="tarde"></el-option>
                <el-option label="NOITE" value="noite"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <!-- Item 1 — "as rotas contendo o endereço de SAÍDA e CHEGADA". -->
            <el-form-item label="Endereço de chegada (destino)" prop="destino" key="destino">
              <el-input v-model="dados.destino" maxlength="191" v-on:blur="formatUpper('destino')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Horário de saída" prop="horario_saida" key="horario_saida">
              <el-time-select v-model="dados.horario_saida" :picker-options="{ start: '00:00', step: '00:05', end: '23:55' }" placeholder="--:--" clearable style="width:100%"></el-time-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Horário de chegada" prop="horario_chegada" key="horario_chegada">
              <el-time-select v-model="dados.horario_chegada" :picker-options="{ start: '00:00', step: '00:05', end: '23:55' }" placeholder="--:--" clearable style="width:100%"></el-time-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Motorista" prop="motorista_id" key="motorista_id">
              <el-select v-model="dados.motorista_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getMotoristaByFilter" :loading="loadingMotorista">
                <el-option v-for="m in motoristas" :key="m.id" :label="m.nome" :value="m.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Veículo" prop="veiculo_id" key="veiculo_id">
              <el-select v-model="dados.veiculo_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getVeiculoByFilter" :loading="loadingVeiculo">
                <el-option v-for="v in veiculos" :key="v.id" :label="v.placa" :value="v.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Monitor" prop="monitor_id" key="monitor_id">
              <el-select v-model="dados.monitor_id" placeholder="pesquisar..." filterable remote clearable :remote-method="getMonitorByFilter" :loading="loadingMonitor">
                <el-option v-for="m in monitores" :key="m.id" :label="m.nome" :value="m.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Quilometragem estimada" prop="quilometragem_estimada" key="quilometragem_estimada">
              <el-input v-model="dados.quilometragem_estimada" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Tempo estimado (min)" prop="tempo_estimado" key="tempo_estimado">
              <el-input v-model="dados.tempo_estimado" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Status" prop="status" :rules="[$requiredChange]" key="status">
              <el-select v-model="dados.status">
                <el-option label="ATIVA" value="ativa"></el-option>
                <el-option label="INATIVA" value="inativa"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
          <!-- ==================== Origem e chegada — item 1 ==================== -->
          <el-divider content-position="left">Origem, chegada e fornecedor</el-divider>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="12">
              <el-form-item label="Endereço de saída" prop="endereco_saida" key="endereco_saida">
                <el-input v-model="dados.endereco_saida" maxlength="255"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Fornecedor (empresa que opera a linha)" prop="fornecedor_id" key="fornecedor_id">
                <el-select v-model="dados.fornecedor_id" placeholder="Selecione" clearable filterable style="width:100%">
                  <el-option v-for="f in fornecedores" :key="f.id" :label="f.nome" :value="f.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-alert type="info" :closable="false" show-icon class="u-mb-10"
                    title="As coordenadas servem ao cálculo da distância; o endereço serve à identificação"
                    description="Uma coisa não é derivada da outra. Sem coordenada, a distância fica indeterminada — e não zero.">
          </el-alert>

          <el-row :gutter="10">
            <el-col :xs="12" :sm="6">
              <el-form-item label="Latitude da saída" key="latitude_saida">
                <el-input v-model="dados.latitude_saida" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="Longitude da saída" key="longitude_saida">
                <el-input v-model="dados.longitude_saida" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="Latitude da chegada" key="latitude_chegada">
                <el-input v-model="dados.latitude_chegada" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="6">
              <el-form-item label="Longitude da chegada" key="longitude_chegada">
                <el-input v-model="dados.longitude_chegada" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ==================== Itinerário e distância — itens 2, 3, 4 e 5 ==================== -->
          <div v-if="dados.id">
            <el-divider content-position="left">Itinerário e distância</el-divider>

            <el-row :gutter="10" class="u-mb-10">
              <el-col :xs="24" :sm="14">
                <el-button type="info" plain icon="el-icon-refresh" size="small"
                           @click="carregarItinerario" :loading="carregandoItin">
                  ATUALIZAR ITINERÁRIO
                </el-button>
                <el-button class="u-ml-10" v-if="podeOperar" type="primary" plain icon="el-icon-odometer" size="small"
                           @click="calcularDistancia(false)" :loading="calculando">
                  CALCULAR DISTÂNCIA
                </el-button>
                <el-button class="u-ml-10" type="warning" plain icon="el-icon-printer" size="small" @click="imprimir">
                  IMPRIMIR ITINERÁRIO
                </el-button>
              </el-col>
            </el-row>

            <div v-if="itinerario">
              <!--
                O número é uma ESTIMATIVA GEOGRÁFICA por Haversine. Dizer isso na tela é
                requisito, não gentileza: sem o aviso, alguém usa como quilometragem
                rodoviária para pagar o fornecedor.
              -->
              <el-alert :type="itinerario.completo ? 'success' : 'warning'" :closable="false" show-icon
                        class="u-mb-10" :title="tituloDistancia">
                <div class="u-fs-12">{{ itinerario.aviso }}</div>
                <div class="u-fs-12" v-if="!itinerario.completo && itinerario.sem_coordenada.length">
                  Sem coordenada: {{ itinerario.sem_coordenada.join(', ') }}.
                </div>
              </el-alert>

              <el-alert v-if="itinerario.centro_mapa && itinerario.centro_mapa.aviso" type="info"
                        :closable="false" show-icon class="u-mb-10"
                        :title="itinerario.centro_mapa.aviso"></el-alert>

              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width:60px;" class="u-text-center">#</th>
                    <th>Parada</th>
                    <th class="hidden-mobile">Endereço</th>
                    <th style="width:150px;" class="u-text-center">Tipo</th>
                    <th style="width:130px;" class="u-text-right">Trecho (km)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in itinerario.paradas" :key="i">
                    <td class="u-text-center">
                      <el-tag size="mini" :type="p.papel === 'origem' ? 'success' : (p.papel === 'destino' ? 'danger' : 'info')">
                        {{ p.papel === 'origem' ? 'S' : (p.papel === 'destino' ? 'C' : p.sequencia) }}
                      </el-tag>
                    </td>
                    <td>{{ p.nome || '—' }}</td>
                    <td class="hidden-mobile">{{ p.endereco || '— não informado' }}</td>
                    <td class="u-text-center">{{ p.tipo_rotulo || '—' }}</td>
                    <td class="u-text-right">
                      <span v-if="i === 0">—</span>
                      <span v-else-if="trecho(i) !== null">{{ formatarKm(trecho(i)) }}</span>
                      <!-- indeterminado NÃO é zero -->
                      <el-tag v-else size="mini" type="warning">indeterminado</el-tag>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-rota" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    // Itinerário calculado pelo BACKEND. A tela nunca recalcula distância.
    itinerario: null,
    carregandoItin: false,
    calculando: false,
    fornecedores: [],
    edit: false,
    filtroInstituicao: { id: '', nome: '' },
    loadingMotorista: false,
    motoristas: [],
    loadingVeiculo: false,
    veiculos: [],
    loadingMonitor: false,
    monitores: [],
    dados: {
      id: '',
      instituicao_id: '',
      nome: '',
      descricao: '',
      destino: '',
      horario_saida: '',
      horario_chegada: '',
      turno: 'manha',
      motorista_id: '',
      veiculo_id: '',
      monitor_id: '',
      quilometragem_estimada: '',

      // BLOCO W — origem, chegada e fornecedor (itens 1 e 28).
      endereco_saida: '',
      latitude_saida: '',
      longitude_saida: '',
      latitude_chegada: '',
      longitude_chegada: '',
      fornecedor_id: '',
      tempo_estimado: '',
      status: 'ativa'
    }
  }),
  computed: {
    podeOperar () { return [0, 1, 4, 5, 6, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },

    tituloDistancia () {
      if (!this.itinerario) return ''
      if (this.itinerario.quilometragem_calculada === null) {
        return 'Distância indeterminada — faltam coordenadas'
      }
      const km = this.formatarKm(this.itinerario.quilometragem_calculada)
      return this.itinerario.completo
        ? `Distância total estimada: ${km} km`
        : `Distância PARCIAL: ${km} km (há trechos sem coordenada)`
    },

    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.carregarFornecedores()
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    /*
     * A distância NÃO é recalculada aqui. A fórmula de Haversine existe uma única vez, no
     * backend — duas implementações divergem no primeiro arredondamento e ninguém descobre
     * qual está certa. A tela apenas EXIBE o que o Service devolveu.
     */
    formatarKm (v) {
      if (v === null || v === undefined) return '—'
      return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    trecho (i) {
      if (!this.itinerario || !this.itinerario.segmentos) return null
      const s = this.itinerario.segmentos[i - 1]
      return s ? s.km : null
    },

    carregarFornecedores () {
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/getAllPaginate`,
                       { tipo_fornecedor: 'transporte', per_page: 200 }, this.$store.getters.getHeaderAuth)
        .then(r => { this.fornecedores = (r.data && !r.data.erro) ? (r.data.data || []) : [] })
        .catch(() => { this.fornecedores = [] })
    },

    carregarItinerario () {
      if (!this.dados.id) return
      this.carregandoItin = true

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/itinerario/${this.dados.id}`,
                      this.$store.getters.getHeaderAuth)
        .then(r => {
          this.carregandoItin = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.itinerario = r.data
        })
        .catch(e => { this.carregandoItin = false; this.$store.commit('throwException', e) })
    },

    /** Item 3 — calcula e grava. Item 4 — não sobrescreve valor manual sem confirmar. */
    calcularDistancia (forcar) {
      this.calculando = true

      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/calcularDistancia/${this.dados.id}`,
                       { forcar: !!forcar }, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.calculando = false

          if (r.data && r.data.exige_confirmacao) {
            return this.$msgbox.confirm(
              `A quilometragem atual (${this.formatarKm(r.data.quilometragem_atual)} km) foi informada ` +
              `manualmente. Substituir pelo valor calculado (${this.formatarKm(r.data.quilometragem_calculada)} km)?`,
              'Atenção', { confirmButtonText: 'Substituir', cancelButtonText: 'Manter', type: 'warning' }
            ).then(() => this.calcularDistancia(true)).catch(() => {})
          }

          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })

          this.dados.quilometragem_estimada = r.data.quilometragem_calculada
          window.eventBus.$emit('alert', { msg: 'Quilometragem calculada.', type: 'success' })
          this.carregarItinerario()
        })
        .catch(e => { this.calculando = false; this.$store.commit('throwException', e) })
    },

    /** Item 5 — abre o PDF do itinerário, gerado no servidor. */
    imprimir () {
      const url = `${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/imprimirItinerario/${this.dados.id}`

      this.$axios.get(url, Object.assign({}, this.$store.getters.getHeaderAuth, { responseType: 'blob' }))
        .then(r => {
          const blob = new Blob([r.data], { type: 'application/pdf' })
          window.open(window.URL.createObjectURL(blob), '_blank')
        })
        .catch(e => this.$store.commit('throwException', e))
    },

    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/getById/` + id, this.$store.getters.getHeaderAuth)

      if (res.data && res.data.erro) {
        return window.eventBus.$emit('alert', { msg: res.data.erro, type: 'warning' })
      }

      const data = JSON.parse(JSON.stringify(res.data))

      // pré-popular selects remotos
      if (data.motorista) { this.motoristas = [{ id: data.motorista.id, nome: data.motorista.nome }]; delete data.motorista }
      if (data.veiculo) { this.veiculos = [{ id: data.veiculo.id, placa: data.veiculo.placa }]; delete data.veiculo }
      if (data.monitor) { this.monitores = [{ id: data.monitor.id, nome: data.monitor.nome }]; delete data.monitor }

      // horário vem do banco como HH:mm:ss; el-time-select espera HH:mm
      if (data.horario_saida) data.horario_saida = String(data.horario_saida).substring(0, 5)
      if (data.horario_chegada) data.horario_chegada = String(data.horario_chegada).substring(0, 5)

      this.dados = data

      // Itens 2 e 3 — o itinerário e a distância vêm do backend, já com o aviso.
      this.carregarItinerario()
    },
    getMotoristaByFilter (query) {
      if (!query || query.length < 2) { this.motoristas = []; return }
      this.loadingMotorista = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/motorista/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.motoristas = JSON.parse(JSON.stringify(res.data)); this.loadingMotorista = false })
        .catch(e => { this.loadingMotorista = false; this.$store.commit('throwException', e) })
    },
    getVeiculoByFilter (query) {
      if (!query || query.length < 2) { this.veiculos = []; return }
      this.loadingVeiculo = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/veiculo/searchByPlaca`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.veiculos = JSON.parse(JSON.stringify(res.data)); this.loadingVeiculo = false })
        .catch(e => { this.loadingVeiculo = false; this.$store.commit('throwException', e) })
    },
    getMonitorByFilter (query) {
      if (!query || query.length < 2) { this.monitores = []; return }
      this.loadingMonitor = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.monitores = JSON.parse(JSON.stringify(res.data)); this.loadingMonitor = false })
        .catch(e => { this.loadingMonitor = false; this.$store.commit('throwException', e) })
    },
    onSubmit () {
      document.getElementById("btn-rota").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
          } else {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/rota/store`, this.dados, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitRota')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        }
      }
    }
  }
}
</script>

